import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useEcgDetailsContext } from "../../../../context/EcgDetailsContext";
import MultiEcgActions from "./MultiEcgAction/MultiEcgAction";
import SingleEcgAction from "./SingleEcgAction/SingleEcgAction";
import styles from "./actions.module.css";

const Actions = () => {
  const {
    state: { loading, ecgEdit },
    actions: { edit },
  } = useEcgDetailsContext();

  const [dirty, setDirty] = useState<boolean>(false);

  const onToggle = (
    selectAction: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!ecgEdit?.actions || !ecgEdit.actions.length) return;

    const id = event.currentTarget.name;
    const actions = ecgEdit.actions;
    for (let i = 0; i < actions.length; i++) {
      const action = actions[i];
      action.value = action.key === id && selectAction;
    }

    setDirty(true);
    edit(ecgEdit);
  };

  useEffect(() => {
    // In case a single action required is on the ecg, set its value to 'undefined' so that both 'No'/'Yes' radio button options would be unselected as default
    if (ecgEdit?.actions && ecgEdit?.actions.length === 1 && !dirty) {
      ecgEdit.actions[0].value = undefined;
    }
  }, [ecgEdit, dirty]);

  return (
    <div className="p-2">
      <p className={`mb-1 font-sm ${styles.headerContainer}`}>
        <p>
          <span className="prim-color">*</span>&nbsp;
          <FormattedMessage
            id="ECG_DETAILS.ACTION_REQUIRED"
            defaultMessage="Action Required"
          />
        </p>
        {ecgEdit?.actionsReviewNote && (
          <p className={styles.actionsReviewNote}>
            {ecgEdit?.actionsReviewNote}
          </p>
        )}
      </p>
      <div className={styles.actionsContainer}>
        {ecgEdit?.actions?.length === 1 ? (
          <SingleEcgAction
            action={ecgEdit?.actions[0]}
            onChange={onToggle}
            disabled={loading || ecgEdit?.isReadable === false}
            dirty={dirty}
          />
        ) : (
          <MultiEcgActions
            actions={ecgEdit?.actions}
            onChange={(e) => onToggle(true, e)}
            disabled={loading || ecgEdit?.isReadable === false}
          />
        )}
      </div>
    </div>
  );
};

export default Actions;
